import WithRender from "../../templates/base/pageOption.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getPageAttributesInPageOptions",
      "getActivePageOptions",
      "getShowTooltipsInPOHeader",
      "getChecked",
      "getCheckedIsNext",
      "getIsShowCheckedPageOptionFlag",
      "getIsCheckedPageOptionActive",
      "getActiveProductPageOptions"
    ]),

    name: function () {
      return this.propsData.label;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOHeader && this.propsData.tooltip;
    },
    checked: function () {
      return this.getChecked(this.index);
    },
    getDisabledClass: function () {
      if (!this.getIsCheckedPageOptionActive) {
        return "";
      }
      return this.checked || this.getCheckedIsNext(this.index)
        ? ""
        : "disabled";
    },
    completed: function () {
      const tabs = Object.keys(this.getActiveProductPageOptions);
      const activeIndex = tabs.indexOf(this.getActivePageOptions);
      const currentIndex = tabs.indexOf(this.code);
      return currentIndex < activeIndex;
    }
  },

  methods: {
    ...mapActions(["setActiveProductPageOption"]),
    onClickSelectPageOption(option) {
      //if (this.completed)
      this.setActiveProductPageOption(option);
    },
    activeClass: function () {
      let classes = "";
      classes += this.completed ? " finished-step " : "  ";
      classes += this.getActivePageOptions == this.code ? " active " : "";
      // classes +=
      //   this.getActivePageOptions != this.code && !this.completed
      //     ? " not-allowed "
      //     : "";

      return classes;
    }
  },
  props: ["propsData", "index", "code"]
});
